import styled from 'styled-components'

export const StatusWrapper = styled.div`
  box-shadow: 2px 2px 8px 2px #74747476;
  background-color: #fff;
  padding: 28px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  .ant-table-content {
    font-family: 'Pretendard';
    .ant-table-thead > tr > th {
      text-align: center;
    }
    .name, .date, .manager, .desc {
      text-align: center;
    }
    .name {
      color: #437EFF;
    }
    .color {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      span {
        width: 16px;
        height: 16px;
        border: 1px solid #101010;
      }
    }
    .btns {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      button {
        background-color: transparent;
        border-radius: 4px;
        padding: 8px 12px;
        font-family: Pretendard;
        font-weight: 700;
        transition: all.3s;
        &.edit {
          border: 2px solid #FF9F01;
          color: #FF9F01;
          &:hover {
            background-color: #FF9F01;
            color: #fff;
          }
        }
        &.delete {
          border: 2px solid #f7514b;
          color: #f7514b;
          &:hover {
            background-color: #f7514b;
            color: #fff;
          }
        }
      }
    }
  }
  .ant-pagination {
    justify-content: center;
  }
`
export const StatusHeader = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`
export const StatusHeaderTitle = styled.p`
  font-size: 16px;
  font-weight: 700;
`
export const StatusHeaderBtn = styled.button`
  border: 2px solid #58ecd6;
  padding: 8px 12px;
  color: #58ecd6;
  font-family: Pretendard;
  background-color: transparent;
  font-weight: 700;
  border-radius: 4px;
  transition: all.3s;
  &:hover {
    color: #101010;
    background-color: #58ecd6;
  }
`
